export default __webpack_public_path__ + "static/media/im.06ea205f.jpg";